export const STRAPI_ERRORS = {
  EMAIL_ALREADY_USED: "Email or Username are already taken",
  INVALID_PASSWORD: "password must be at least 6 characters",
  PASSWORDS_NOT_MATCH: "Passwords do not match",
}
